import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'
import { UserAvatar } from './UserAvatar'
import type { UserSearchResult } from '../types'

interface UserSearchResultRowProps {
  readonly result: UserSearchResult
  readonly onInvite: (userId: string) => void
  readonly onBlock: (userId: string) => void
  readonly isInviting: boolean
}

export function UserSearchResultRow({
  result,
  onInvite,
  onBlock,
  isInviting,
}: UserSearchResultRowProps) {
  const { t } = useTranslation()
  const alreadyLinked = result.is_friend || result.request_pending

  return (
    <li className="flex items-center gap-3 rounded-2xl bg-surface-low px-4 py-3">
      <UserAvatar username={result.username} avatarUrl={result.avatar_url} />

      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-sm font-semibold text-on-surface">{result.username}</span>
        {result.display_name && (
          <span className="truncate text-xs text-on-surface-variant">{result.display_name}</span>
        )}
      </span>

      {alreadyLinked ? (
        <span className="text-xs font-medium text-on-surface-variant">
          {result.is_friend ? t('social.search.already_friend') : t('social.search.pending')}
        </span>
      ) : (
        <Button size="sm" onClick={() => onInvite(result.id)} isLoading={isInviting}>
          {t('social.search.invite')}
        </Button>
      )}

      <Button
        size="sm"
        variant="ghost"
        onClick={() => onBlock(result.id)}
        aria-label={t('social.moderation.block_user', { username: result.username ?? '' })}
      >
        {t('social.moderation.block')}
      </Button>
    </li>
  )
}
